import React, { useEffect } from 'react';
import { AppDispatch, useAppSelector } from '../store';
import { useDispatch } from 'react-redux';
import BASE_URL from '../constants/Config';
import { fetchServices } from '../store/feature/serviceSlice';
import { Link } from 'react-router-dom';

function Services() {
  const dispatch = useDispatch<AppDispatch>();
  const { services } = useAppSelector((state) => state.service);

  useEffect(() => {
    dispatch(fetchServices())
  }, [dispatch]);

  const slugify = (text: string) => {
    return text
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
  };

  const getPhotoUrl = (filePath: string) => {
    const fileName = filePath.split('/').pop();
    return `${BASE_URL}/api/OurServices/photo/${fileName}`;
  };

  const truncateText = (text: string, maxLength: number) =>
    text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="bg-gray-900 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-6">Hizmetlerimiz</h1>
        </div>
      </section>

      {/* Services Grid - Güncellenmiş kısım */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img 
                  src={getPhotoUrl(service.photoUrl)}
                  alt={service.title} 
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3">{service.title}</h3>
                  <p className="text-sm text-gray-600 mb-4">{truncateText(service.content, 150)}</p>
                  <button className="mt-2 text-blue-600 font-semibold hover:text-blue-800 transition-colors duration-200">
                    <Link to={`/services/${slugify(service.title)}`}>Devamını Gör →</Link>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;